import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { MainService } from '../../service/main.service';
import { ApiUrls } from '../../apiRouts';
import { ToasterServiceService } from '../../service/toaster.service';
import { ConfirmDialog } from '../../shared/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-village',
  templateUrl: './village.component.html',
  styleUrl: './village.component.scss'
})
export class VillageComponent implements OnInit {
  VillageForm: any = FormGroup;
  buttonclick: boolean = false;
  submitted: boolean = false;
  selectDistrict: any;
  villageData: any;
  subdivision_id: any;
  villageListData: any[] = [];
  @ViewChild('scroll', { read: ElementRef })
  public scroll!: ElementRef<any>;

  constructor(
    private location: Location,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private toasterService: ToasterServiceService,
    private router: Router, 
    private mainService: MainService,    
    public dialog: MatDialog) {
    this.selectDistrict = this.mainService.selectDistrict;
    this.VillageForm = this.fb.group({
      village_name: ['', [Validators.required]],
      village_id: [0],
    })
  }

  ngOnInit(): void {
    this.route.params.subscribe((params: any) => {
      this.subdivision_id = params['id'];
    })
    this.getVillage();
  }

  goBackToPrevPage() {
    this.location.back();
  }

  get f() {
    return this.VillageForm.controls;
  }

  navigateToSubdivision(data: any) {
    this.router.navigate(['/city/subdivision-list'],
    );
  }

  getVillage() {
    this.mainService.getApi(ApiUrls.villageList + this.subdivision_id).subscribe((res: any) => {
      if (res.status == 1) {
        this.villageData = res.village
        this.villageListData = res.village
      }
    });
  }

  EditVillage(data: any) {
    this.buttonclick = true;
    this.VillageForm.patchValue({
      subdivision_id: data.subdivision_id,
      village_name: data.village_name,
      village_id: data.village_id,
    });
    this.scroll.nativeElement.scrollTop = 0;
  }

  applySearch(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.toLowerCase();
    if (!filterValue) {
      this.villageData = [...this.villageListData];
      return;
    }
    this.villageData = this.villageListData.filter((data: any) => {
      return data.village_name.toLowerCase().includes(filterValue)
    });
  }

  villageAdd() {
    this.submitted = true;
    if (this.VillageForm.valid) {
      let data = {
        subdivision_id: Number(this.subdivision_id),
        village_id: 0,
        village_name: this.VillageForm.value.village_name,
        Action: 'Insert',
      };
      this.mainService.postApi(ApiUrls.addVillage, data, 1).subscribe((res: any) => {
        if (res.status == 1) {
          this.toasterService.toastSuccess(res.response);
          this.getVillage();
        }
        else {
          this.toasterService.toastError(res.response);
        }
      });
      this.VillageForm.reset();
      this.submitted = false;
    } else {
      this.submitted = true;
    }
  }

  villageEdit() {
    let data = {
      subdivision_id: Number(this.subdivision_id),
      village_id: this.VillageForm.value.village_id,
      village_name: this.VillageForm.value.village_name,
      Action: 'Update',
    };
    if (this.VillageForm.valid) {
      this.mainService.putApi(ApiUrls.editVillage, data, 1).subscribe((res: any) => {
        if (res.status == 1) {
          this.toasterService.toastSuccess(res.response);
          this.getVillage();
          this.VillageForm.reset();
          this.submitted = false;
          this.buttonclick = false;
        }
      });

    } else {
      this.submitted = true
      this.buttonclick = true;
    }
  }

  openDialog(e: any, data: any): void {
    const dialogRef = this.dialog.open(ConfirmDialog, {
      data: {
        page: 'JobList'
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == 1) {
        this.deleteVillage(data);
      } else {
        e.source.checked = !e.checked;
        data.status = e.checked == true ? 0 : 1;
      }
    });
  }

  deleteVillage(data: any) {
    let obj = {
      subdivision_id: 0,
      village_id: Number(data.village_id),
      village_name: '',
      Action: 'DELETE',
    };
    this.mainService.postApi(ApiUrls.addVillage, obj, 1).subscribe((res: any) => {
      if (res.status == 1) {
        this.toasterService.toastSuccess(res.response);
        this.getVillage();
      }
      else {
        this.toasterService.toastError(res.response);
      }
    });
  }
}
